{
  "name": "Clock Kill Button",
  "powerupName": "ClockMagnet",
  "levelUpDescriptions": [
    "ClockMagnetUpgradeDescription1",
    "ClockMagnetUpgradeDescription2",
    "ClockMagnetUpgradeDescription3",
    "ClockMagnetUpgradeDescription4",
    "ClockMagnetUpgradeDescription5"
  ]
}